<template>
  <div class="detail">
    <Nav/>

    
    <div
      class="status"
      :class="detail.status == 1 && 'status1' || detail.status == 4 && 'status2' || 'status3'"
    >
      <span
        class="t1"
      >{{ detail.status == 0 && '待设置运费' || detail.status == 1 && '待付款' || detail.status ==2 && '待发货' || detail.status == 3 && '待收货' || detail.status == 4 && '待评价' || detail.status == 5 && '售后中' || detail.status == 6 && '退款中' || detail.status == 7 && '已退款' }}</span>
      <span class="t2" v-if="detail.status == 2">买家已付款，等待卖家发货</span>
      <span class="t2" v-if="detail.status == 1 && time">
        <van-count-down :time="time">
          <template v-slot="timeData">
            <span class="item">{{ timeData.hours }}小时</span>
            <span class="item">{{ timeData.minutes }}分</span>
            <span class="item">{{ timeData.seconds }}秒</span>
            <span class="item">后关闭</span>
          </template>
        </van-count-down>
      </span>
    </div>

    <div class="noLogs" v-if="detail.status == 2">
      <img src="../../assets/my/addrIcon.png" />
      <span>暂无物流信息</span>
      <div class="next">></div>
    </div>


    
    <router-link tag="div" :to="{name:'orderLogs',query:{id:detail.id,sn:detail.sn}}" class="logs" v-if="detail.status == 3 && detail.type != 2 &&  detail.express_content &&detail.express_content.Traces.length ">
      <div class="imgbox">
        <img src="../../assets/my/addrIcon.png" alt />
      </div>
      <div class="log">
        <div
          class="t1"
        >{{ detail.express_content.Traces[detail.express_content.Traces.length-1].AcceptStation }}</div>
        <div
          class="t2"
        >{{ detail.express_content.Traces[detail.express_content.Traces.length-1].AcceptTime }}</div>
      </div>
      <div class="t3">></div>
    </router-link>

    <address>
      <div class="imgbox">
        <img src="../../assets/my/address.png" alt />
      </div>
      <div class="userAddr">
        <div
          class="name"
        >{{ detail.receive_json.receive_name +' '+ detail.receive_json.receive_tel }}</div>
        <div
          class="t1"
        >{{ detail.receive_json.address_path_title | pcaFilter }} {{ detail.receive_json.receive_address | Faddress }}</div>
      </div>
      <img src="../../assets/car/line.png" class="img1" alt />
    </address>

    <div class="goodsbox">
      <Goods v-for="item in detail._child" :key="item.id" :goods="item" />
    </div>
    <div class="price">
      <span class="t1">共{{ detail.num }}件商品 合计：</span>
      <span class="t2">￥{{ detail.money }}</span>
    </div>

    <div class="orderInfor">
      <div class="t_list">
        <span class="t1">订单号：</span>
        <span class="t2">{{ detail.sn }}</span>
        <div class="btn" @click="copySN(detail.sn)">复制</div>
      </div>
      <div class="t_list" v-if="detail.express_content && detail.express_content.express_company">
        <span class="t1">{{ detail.express_content.express_company }}:</span>
        <span class="t2">{{ detail.express_content.express_sn }}</span>
        <div class="btn" @click="copySN(detail.express_content.express_sn)">复制</div>
      </div>
      <div class="t_list">
        <span class="t1">下单时间：</span>
        <span class="t2">{{ detail.add_time }}</span>
      </div>
      <div class="t_list" v-if="detail.pay_time">
        <span class="t1">付款时间：</span>
        <span class="t2">{{ detail.pay_time }}</span>
      </div>
      <div class="t_list">
        <span class="t1">客服电话：</span>
        <span class="t2">{{ detail.aftersale_tel }}</span>
      </div>
    </div>

    <div class="operate">
      <div class="item" @click="cancel" v-if="detail.status == 1">取消订单</div>

      <div class="item" @click="pay" v-if="detail.status == 1">去支付</div>

      <div
        class="item"
        @click="tuikuan"
        v-if="detail.source == 1 && detail.status == 2  || detail.source == 2 && detail.status == 2"
      >申请退款</div>

      <div class="item" @click="sureOrder" v-if="detail.status == 3 ">确认收货</div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.detail {
  .van-count-down{
    display: flex;
    align-items: center;
    .item{
      font-size: 28px;
    }
  }


  .status {
    width: 100%;
    height: 160px;
    box-sizing: border-box;
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-repeat: no-repeat;
    background-size: 100%;
    span {
      display: block;
      color: #fff;
    }
    .t1 {
      font-size: 36px;
      margin-bottom: 10px;
    }
    .t2 {
      font-size: 24px;
    }
  }
  .status3 {
    background-image: url("../../assets/my/order.png");
  }
  .status1 {
    background-image: url("../../assets/my/isPay.png");
  }
  .status2 {
    background-image: url("../../assets/my/orderEva.png");
  }
  .noLogs {
    width: 100%;
    height: 100px;
    box-sizing: border-box;
    padding: 0 24px;
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #eee;
    img {
      width: 45px;
      margin-right: 30px;
    }
    span {
      display: inline-block;
      flex: 1;
      font-size: 28px;
      color: #333;
    }
    .next {
      font-size: 30px;
      color: #a5a5a5;
      transform: scaleY(1.8);
    }
  }
  .logs {
    width: 100%;
    height: 170px;
    box-sizing: border-box;
    padding: 20px 24px;
    background-color: #fff;
    display: flex;
    align-items: center;
    .imgbox {
      height: 170px;
      width: 40px;
      box-sizing: border-box;
      padding-top: 30px;

      img {
        width: 40px;
      }
    }
    .log {
      flex: 1;
      overflow: hidden;
      margin-left: 30px;
      .t1 {
        font-size: 28px;
        color: #e42129;
        margin-bottom: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .t2 {
        font-size: 24px;
        color: #999;
      }
    }
    .t3 {
      transform: scaleY(1.8);
      color: #999;
      font-size: 30px;
    }
  }

  address {
    width: 100%;
    box-sizing: border-box;
    padding: 0 24px;
    display: flex;
    align-items: center;
    position: relative;
    background-color: #fff;
    .imgbox {
      height: 170px;
      width: 40px;
      box-sizing: border-box;
      padding-top: 30px;
      img {
        width: 40px;
      }
    }
    .userAddr {
      height: 170px;
      width: 100%;
      box-sizing: border-box;
      padding: 30px;
      .name {
        font-size: 32px;
        color: #121212;
        margin-bottom: 12px;
      }
      .t1 {
        font-size: 28px;
        color: #333;
      }
    }
    .img1 {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 6px;
    }
  }
  .goodsbox {
    margin-top: 30px;
    background-color: #fff;
    width: 100%;
    box-sizing: border-box;
    padding: 30px 24px;
  }
  .price {
    width: 100%;
    height: 78px;
    box-sizing: border-box;
    padding: 0 24px;
    border-top: 2px solid #eee;
    text-align: right;
    line-height: 78px;
    font-size: 24px;
    color: #666;
    background-color: #fff;
    .t2 {
      font-size: 32px;
      color: #e42129;
    }
  }
  .orderInfor {
    padding: 30px 24px;
    width: 100%;
    height: 230px;
    margin-top: 20px;
    background: #fff;
    box-sizing: border-box;
    .t_list {
      display: flex;
      align-self: center;
      font-size: 24px;
      margin: 12px 0;
      .t1 {
        color: #666;
      }
      .t2 {
        flex: 1;
        color: #333;
      }
      .btn {
        color: #e42129;
      }
    }
  }
  .operate {
    width: 100%;
    height: 99px;
    box-sizing: border-box;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-color: #fff;
    .item {
      width: 145px;
      height: 45px;
      border: 1Px solid #ccc;
      line-height: 45px;
      text-align: center;
      font-size: 24px;
      color: #353535;
      border-radius: 10px;
      margin-left: 10px;
    }
  }
}
</style>

<script>
import Goods from "../../component/goods/GoodsOrder";
import copy from 'clipboard-copy'
export default {
  components: {
    Goods
  },
  data() {
    return {
      detail: {},
      time: null,
      timeData:null
    };
  },
  created() {
    let id = this.$route.query.id;
    this.$http({
      url: "orderDeatil",
      data: {
        id
      }
    }).then(res => {

      let { receive_json, express_json } = res;
      res.receive_json = JSON.parse(receive_json);
      res.express_json = JSON.parse(express_json)
      let num = 0;

      let child = res._child.data;

      let is_sale = false

      child.forEach(item => {
        num += Math.floor(item.num)
        
        if(item.orders_service_id){
          console.log('>>>>>>>.')
          is_sale = true
        }
      });
      res.is_sale = is_sale
      res._child = child;
      res.num = num;
      this.detail = res;
      console.log(this.detail)
      let time = res.add_time;
      let thisTime = time;
      thisTime = thisTime.replace(/-/g, "/");
      time = new Date(thisTime);
      this.time =  1000 * 60 * 60 * 24 + time.getTime() - new Date().getTime();
    });
  },
  methods: {
    copySN(sn){
      copy(sn)
      this.$toast('复制成功')
    },
    cancel() {
      let id = this.detail.id;

      this.$http({
        url: "cancelOrders",
        data: {
          id
        }
      }).then(res => {
        this.$toast("取消成功");
        setTimeout(() => {
          this.$router.go(-1);
        }, 1500);
      });
    },
    pay() {
      let id = this.detail.id;

      this.$router.push({ name: "orderCommit", query: { id } });
    },
    tuikuan() {
      let id = this.detail.id;

      this.$dialog
        .confirm({
          message: "是否确认退款"
        })
        .then(() => {
          // on confirm
          this.$http({
            url: "refund",
            data: {
              id
            }
          }).then(res => {
            this.$toast("退款成功");
            setTimeout(() => {
              this.$router.go(-1);
            }, 1500);
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    sureOrder() {
      let id = this.detail.id;

      this.$http({
        url: "surGet",
        data: {
          id
        }
      }).then(res => {
        this.$toast("收货成功");
        setTimeout(() => {
          this.$router.go(-1);
        }, 1500);
      });
    }
  }
};
</script>
